<template>
  <div>
    <div>
      <input
        type="radio"
        id="rdo_editor_dummy"
        name="editor_component"
        :value="'dummy'"
        v-model="twEditorComponent"
      />
      <label for="rdo_editor_dummy">Dummy</label>
      <input
        type="radio"
        id="rdo_editor_ace"
        name="editor_component"
        :value="'ace'"
        v-model="twEditorComponent"
      />
      <label for="rdo_editor_ace">Ace</label>
    </div>
    <div v-if="twEditorComponent == 'dummy'">
      <JsonEditorDummy :value="valueText" @inputText="emitInput" />
    </div>
    <div v-if="twEditorComponent == 'ace'">
      <JsonEditorAce :value="valueText" @inputText="emitInput" />
    </div>
    <!-- Invalid JSON -->
    <span v-if="isInvalid">Invalid JSON</span>
    <!-- JSON Path -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import JsonEditorDummy from '@/components/JsonEditorDummy.vue'
import JsonEditorAce from '@/components/JsonEditorAce.vue'

export default {
  name: 'JsonEditor',
  props: ['value'],
  data() {
    return {
      invalidJson: '',
      isInvalid: false
    }
  },
  computed: {
    valueText: function() {
      if (this.isInvalid) return this.invalidJson
      return JSON.stringify(this.value, null, 2)
    },
    twEditorComponent: {
      get() {
        return this.editorRenderer
      },
      set(value) {
        this.setEditorRenderer(value)
      }
    },
    ...mapState(['editorRenderer'])
  },
  mounted: function() {
    this.loadEditorRenderers()
  },
  methods: {
    emitInput(text) {
      try {
        let json = JSON.parse(text)
        this.$emit('input', json)
        this.isInvalid = false
      } catch {
        this.invalidJson = text
        this.isInvalid = true
        // Wait for JSON to be ok
      }
    },
    ...mapMutations(['setEditorRenderer', 'loadEditorRenderers'])
  },
  components: {
    JsonEditorAce,
    JsonEditorDummy
  }
}
</script>
